import { createContext, useState, useContext, useRef } from "react";

const PostContext = createContext();

export const usePostContext = () => useContext(PostContext);

export const PostContextProvider = ({ children, editRoute, previewRoute, viewRoute, entityType }) => {
  // States
  const [activeGridItemActions, setActiveGridItemActions] = useState({});
  const [activeGridItem, setActiveGridItem] = useState(null);
  const [showPublish, setShowPublish] = useState(false);
  const [showUnpublish, setShowUnpublish] = useState(false);
  const [showPostSettings, setShowPostSettings] = useState(false);
  const [sharePostItem, setSharePostItem] = useState(null);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [hideShare, setHideShare] = useState(false);

  // Refs
  const postDeleteFunctionRef = useRef(null);

  // Registers
  const registerPostDeleteFunction = (fn) => {
    postDeleteFunctionRef.current = fn;
  };

  // Triggers
  const triggerPostDeleteFunction = (value) => {
    if (postDeleteFunctionRef.current) {
      postDeleteFunctionRef.current(value);
    }
  };

  return (
    <PostContext.Provider
      value={{
        activeGridItemActions,setActiveGridItemActions,
        activeGridItem, setActiveGridItem,
        sharePostItem, setSharePostItem,
        shareModalOpen, setShareModalOpen,
        showPublish, setShowPublish,
        showUnpublish, setShowUnpublish,
        showPostSettings, setShowPostSettings,
        hideShare, setHideShare,
        editRoute,
        previewRoute,
        viewRoute,
        entityType,
        registerPostDeleteFunction,
        triggerPostDeleteFunction,
      }}
    >
      {children}
    </PostContext.Provider>
  );
};
